module.exports = __webpack_public_path__ + "static/media/loginPage.79eb068d.png";